import moment from 'moment';

export const isFirstMonthAfterAdd = (dateOfAdd: string | null): boolean => {
  if (!dateOfAdd) {
    return false;
  }

  const addDate = moment(dateOfAdd);
  const currentDate = moment();
  const daysDiff = currentDate.diff(addDate, 'days');
  return daysDiff <= 30;
};
